import script from "./TheDisplayed.vue?vue&type=script&setup=true&lang=js"
export * from "./TheDisplayed.vue?vue&type=script&setup=true&lang=js"

import "./TheDisplayed.vue?vue&type=style&index=0&id=5909be39&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5909be39"]])

export default __exports__